import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputNumberItem,
  SelectItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
} from "../../../../Components/Items";

const { Option } = Select;

class AgregarControlInventario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: null,
    todasInsumos: [],
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  cerrarAgregarControlInventario(codigo) {
    this.props.cerrarAgregarControlInventario(codigo);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "controlInventario/agregarControlInventario",
        { ...values, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se agrego un control de inventario");
          this.formRef.current.resetFields();
          this.cerrarAgregarControlInventario();
        } else if (res.data.success === 1) {
          message.error(res.data.message);
        } else {
          message.error("Sucedio un error y no se guardo");
        }
      });
  }
  render() {
    return (
      <>
        <ModalItem
          title="Agregar Control Inventario"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarControlInventario.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="AgregarControlInventario"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem label="Proyecto" name="proyectoId" margin>
              <SelectItem placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
            <FormItem label="Insumo" name="insumoId" required margin>
              <SelectInsumosItem
                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                headersToken={this.props.headersToken}
                sinBorde
                autoFocus
                dropdownMatchSelectWidth={600}
                width="100%"
                placeholder="Insumo"
                tiposInsumos="inventariables"
              />
            </FormItem>
            <FormItem
              label="Mín"
              name="min"
              margin
              required
              numberCero
            >
              <InputNumberItem placeholder="Mín" />
            </FormItem>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const min = getFieldValue('min')
                return (
                  <FormItem
                    label="Máx"
                    name="max"
                    margin
                    required
                    type='number'
                    gt={min}
                    numberCero
                  >
                    <InputNumberItem placeholder="Máximo" />
                  </FormItem>
                )
              }}
            </FormItem>
            <FormItem label="Modo de requisición" name="modoRequisicion" margin>
              <SelectItem placeholder="Usar configuración global" allowClear>
                <Option value="automatico">Generar automáticamente</Option>
                <Option value="sugerencia">Solo sugerir</Option>
              </SelectItem>
            </FormItem>
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarControlInventario);
